import { useTranslation } from 'react-i18next'

import { Dialog, DialogDeleteBody } from '@percent/admin-dashboard/common/components'
import type { ConfirmToggleModalProps } from './ConfirmToggleModal.types'

export function ConfirmToggleModal({
  isOpen,
  label,
  newEnabled,
  isLoading,
  errorMessage,
  onConfirm,
  onClose
}: ConfirmToggleModalProps) {
  const { t } = useTranslation()

  const action = newEnabled ? t('partnerConfig.action.enable') : t('partnerConfig.action.disable')
  const headerTitle = t('partnerConfig.confirmModal.title', { action, label })

  return (
    <Dialog openModal={isOpen} onClose={onClose} headerTitle={headerTitle}>
      <DialogDeleteBody
        bodyText={t('partnerConfig.confirmModal.body', { action: action.toLowerCase(), label })}
        errorMessage={errorMessage ?? ''}
        handleSubmit={onConfirm}
        buttonTitle={isLoading ? t('button.confirming') : t('button.confirm')}
        isLoading={isLoading}
        testId="confirm-toggle-button"
      />
    </Dialog>
  )
}
